export { default as PageFooter } from './main.vue';
